import { Component } from "@angular/core";

@Component({
  selector: "app-not-found",
  template: ` <brd-404-not-found btnText="Demo Portal" (action)="redirect()"></brd-404-not-found> `
})
export class NotFoundComponent {
  constructor() {}

  redirect(): void {
    window.location.href = "/";
  }
}
